document.addEventListener("scroll", function () {
    const header = document.querySelector(".js-header");
    if (window.scrollY > 1) {
        header.classList.add("header--fixed");
    } else {
        header.classList.remove("header--fixed");
    }
});

document.querySelectorAll(".js-open-megamenu").forEach(menuTrigger => {
    menuTrigger.addEventListener("mouseover", function () {
        document.querySelectorAll(".js-megamenu").forEach(menu => {
            menu.classList.remove("active");
        });

        const parentMegamenu = menuTrigger.parentElement.querySelector(".js-megamenu");
        if (parentMegamenu) {
            parentMegamenu.classList.add("active");
        }
    });
});

document.querySelectorAll('.js-open-megamenu').forEach(trigger => {
  trigger.addEventListener('mouseenter', () => {
    const li = trigger.closest('li');
    if (!li) return;

    const ul = li.closest('ul');
    if (!ul) return;

    ul.querySelectorAll('li.active').forEach(otherLi => {
      if (otherLi !== li) {
        otherLi.classList.remove('active');
        clearTimeout(otherLi._removeActiveTimeout); 
      }
    });

    li.classList.add('active');

    clearTimeout(li._removeActiveTimeout);

    li.addEventListener('mouseleave', () => {
      li._removeActiveTimeout = setTimeout(() => {
        li.classList.remove('active');
      }, 500);
    }, { once: true });
  });
});

document.addEventListener("DOMContentLoaded", function () {
    let counter = 1;
    let lastHover = '';
    document.querySelectorAll(".js-megamenu-get-image").forEach(item => {
        item.addEventListener("mouseenter", function () {
            const index = this.getAttribute("data-index");
            const matchingImage = document.querySelector(`.js-megamenu-image[data-index='${index}']`);
            
            if (matchingImage) {
                if (matchingImage.classList.contains("active") && lastHover != index) {
                    matchingImage.style.opacity = "0";
                    matchingImage.style.transition = "none";
                    setTimeout(() => {
                        matchingImage.style.transition = "opacity 0.45s ease-in-out";
                        matchingImage.style.opacity = "1";
                    }, 10);
                }
                matchingImage.classList.add("active");
                matchingImage.style.zIndex = counter;
                counter++;
                lastHover = index;
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-go-to-second-step").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            document.querySelector(".js-mobile-menu-steps").classList.add("active");
            
            document.querySelectorAll(".js-mobile-subnav").forEach(subnav => {
                subnav.classList.add("d-none");
            });
            
            const index = this.getAttribute("data-index");
            const targetSubnav = document.querySelector(`.js-mobile-subnav[data-index='${index}']`);
            if (targetSubnav) {
                targetSubnav.classList.remove("d-none");
            }
        });
    });
    
    document.querySelectorAll(".js-mobile-menu-back").forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            document.querySelector(".js-mobile-menu-steps").classList.remove("active");
        });
    });

    document.querySelector(".js-open-mobile-menu").addEventListener("click", function (event) {
        event.preventDefault();
        
        document.querySelector(".js-header").classList.toggle("header--with-mobile-menu");
        document.querySelector(".js-mobile-menu").classList.toggle("active");
    });
});